import { createI18n } from "vue-i18n";
const currentLocale = () => {
  return "pt";
};

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context("@/lang", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = createI18n({
  legacy: false,
  locale: currentLocale(),
  fallbackLocale: currentLocale(),
  messages: loadLocaleMessages(),
  globalInjection: true,
});

export default i18n;

import * as validators from "@vuelidate/validators";

const { createI18nMessage } = validators;
const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) });

// wrap each validator.
export const required = withI18nMessage(validators.required, {
  withArguments: true,
});
export const requiredIf = withI18nMessage(validators.requiredIf, {
  withArguments: true,
});
// wrap each validator.
export const email = withI18nMessage(validators.email);
export const minLength = withI18nMessage(validators.minLength, {
  withArguments: true,
});
export const maxLength = withI18nMessage(validators.maxLength, {
  withArguments: true,
});
export const url = withI18nMessage(validators.url, { withArguments: true });
export const minValue = withI18nMessage(validators.minValue, {
  withArguments: true,
});
export const maxValue = withI18nMessage(validators.maxValue, {
  withArguments: true,
});
//export
//helpers.withMessage('This field cannot be empty', required)

const sameAsCustom = withI18nMessage(validators.sameAs, {
  withArguments: true,
  messagePath: ({ $params }) =>
    i18n.global.t("validations.sameAs", [$params.otherName]),
});
export const sameAs = (name, other) =>
  validators.helpers.withParams({ type: "sameAs" }, sameAsCustom(other, name));

import { isValidCNPJ, isValidCPF } from "./cpfCnpjValidator";
import { TipoClienteEnum } from "./enums";
export const cpfOrCnpjValidator = (tipoCliente) =>
  
  validators.helpers.withMessage(
    () => {
      if (tipoCliente.value == TipoClienteEnum.PessoaFisica) {
        return "CPF inválido";
      } else if (tipoCliente.value == TipoClienteEnum.PessoaJuridica) {
        return "CNPJ inválido";
      }
      return "Tipo de cliente inválido";
    },
    validators.helpers.withParams(
      { type: "cpfOrCnpjValidator", tipoCliente: tipoCliente.value },
      function (value) {
        //evitar exibir mensagem de valor incorreto quando valor em branco
        if (!value || value.trim() == "") {
          return true;
        }
        if (tipoCliente.value == TipoClienteEnum.PessoaFisica) {
          return isValidCPF(value);
        } else if (tipoCliente.value == TipoClienteEnum.PessoaJuridica) {
          return isValidCNPJ(value);
        }
        return false;
      }
    )
  );

function isValidAddress(address) {
  return (
    address.logradouro &&
    address.numero &&
    address.bairro &&
    address.cidade &&
    address.uf &&
    address.cep
  );
}
export const requiredAddress = validators.helpers.withMessage(
  "Endereço não está completo, edite para revisar os campos obrigatórios",
  (value) => isValidAddress(value)
);
export const requiredAddressIf = (boolValue) =>
  validators.helpers.withMessage(
    () => {
      return "Endereço não está completo, edite para revisar os campos obrigatórios";
    },
    validators.helpers.withParams(
      { type: "requiredAddressIf" },
      function (value) {
        //evitar exibir mensagem de valor incorreto quando valor em branco
        if (boolValue.value === true) {
          return isValidAddress(value);
        }
        return true;
      }
    )
  );

export const requiredUniqueCodigo = (turnos) =>
  validators.helpers.withMessage(
    "O código já existe",
    validators.helpers.withParams({ type: "requiredUniqueCodigo" }, (value) => {
      if (!value || value.trim() === "") return false;
      const isUnique = !turnos.value.some((turno) => {
        return turno.codigo === value;
      });
      return isUnique;
    })
  );
